import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { RemindersComponent } from 'app/components/shared/reminders/reminders.component';
import { AppPageGroupModel } from 'app/models/shared/appPage.model';
import { MenuService } from 'app/services/menu.service';
import { TaskService } from 'app/services/task.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-menu-default',
    templateUrl: './menu-default.component.html',
    styleUrls: ['./menu-default.component.scss'],
    standalone: false
})
export class MenuDefaultComponent implements OnInit {

    @Input() pageGroup: AppPageGroupModel
    
    private stateSubs: Subscription[] = [];

    constructor(
        private router: Router,
        private modalController: ModalController,
        private taskService: TaskService,
        public menuService: MenuService
    ) { }

    ngOnInit() 
    { 
        const pickBestChildIcon = (children) => {
            if (!children || children.length === 0) return null;

            // Prefer a danger icon if any child has one.
            const danger = children.find(c => !!c?.statusIcon && (c.statusIconColor === 'danger'));
            if (danger) return { icon: danger.statusIcon, color: danger.statusIconColor };

            const first = children.find(c => !!c?.statusIcon);
            if (first) return { icon: first.statusIcon, color: first.statusIconColor };

            return null;
        };

        const apply = (pages, spinnerMap, iconMap) => {
            pages.forEach(p => {
                // Apply state to children first so we can aggregate up to the parent.
                if (p.children) apply(p.children, spinnerMap, iconMap);

                if (p.url) {
                    const ownSpinner = !!spinnerMap[p.url];
                    const ownIconObj = iconMap[p.url];

                    const childSpinner = !!(p.children && p.children.some(c => !!c?.spinner));
                    const childIconObj = pickBestChildIcon(p.children);

                    p.spinner = ownSpinner || childSpinner;

                    if (ownIconObj) {
                        p.statusIcon = ownIconObj.icon;
                        p.statusIconColor = ownIconObj.color;
                    }
                    else if (!p.spinner && childIconObj) {
                        p.statusIcon = childIconObj.icon;
                        p.statusIconColor = childIconObj.color;
                    }
                    else if (!p.spinner) {
                        p.statusIcon = null;
                        p.statusIconColor = null;
                    }
                }
            });
        };

        const combine = () => {
            const sp = this.menuService['menuSpinnerMapSubject'].value;
            const ic = this.menuService['menuStatusIconMapSubject'].value;
            if (this.pageGroup?.pages) apply(this.pageGroup.pages, sp, ic);
        };

        this.stateSubs.push(this.menuService.menuSpinnerMap$.subscribe(_ => combine()));
        this.stateSubs.push(this.menuService.menuStatusIconMap$.subscribe(_ => combine()));

    }

    trackByFn(index: number, item: any)
    {
        return item.url || index;
    }

    async toggleSubMenu(ev, page)
    {
        ev.stopPropagation();
        
        // if (this.isDesktop())
        // {
        //     if (!this.router.url.includes(page.url))
        //     {
        //         this.router.navigate([page.url]);
        //     } 
        // }
        // else
        // {
            page.subMenuOpen = !page.subMenuOpen;
        // }
        
    }

    async collapseAllMenus()
    {
        this.pageGroup

        this.pageGroup.pages.forEach((page) =>
        {
            page.subMenuOpen = false;
        });
        
    }

    async handleMenuClick(action: string)
    {
        switch (action)
        {
            case 'reminders':
                const remindersModal = await this.modalController.create({
                    component: RemindersComponent,
                    componentProps: { taskService: this.taskService },
                    initialBreakpoint: 1,
                    breakpoints: [0, 0.75, 1]

                });
                remindersModal.onDidDismiss().then(() => {
                    this.taskService.setRemindersComponentOpen(false);
                });
                this.taskService.setRemindersComponentOpen(true);
                remindersModal.present();
                break;
            default:
                break;
        }
    }

    ngOnDestroy() {
        this.stateSubs.forEach(s => s.unsubscribe());
    }
}
